import { BasicScrollView } from "@/components/BasicScrollView";
import Head from 'expo-router/head';
import Footer from '@/components/Footer';
import * as TextBlocks from '@/utilities/TextBlocks';
import { MarkdownBlock } from '@/utilities/TextBlocks';
import { Meta } from "@/components/Meta";

export default function DataProcessing() {
  return (
    <BasicScrollView center={false}>
      <Meta title={"Data processing agreement"} />
      <MarkdownBlock markdown={TextBlocks.DATA_PROCESSING_AGREEMENT_MARKDOWN} />
      <Footer />
    </BasicScrollView>
  );
}
